import React from 'react'
import { Icon } from 'xadmin-ui'
import { _t } from 'xadmin-i18n'
import { Tag } from 'antd'

export default ({ value, schema }) => {
  const { boolLabel } = schema
  const trueOps = boolLabel && (boolLabel.filter(v => !_.isNil(v?.value) && v.value)[0] || boolLabel[0])
  const falseOps = boolLabel && (boolLabel.filter(v => !_.isNil(v?.value) && !v.value)[0] || boolLabel[1])
  return (
    <>
      {
        value ?
          (trueOps ?
            <Tag icon={<Icon name={trueOps.icon || "check-circle" }/>} color={trueOps.color || "success"}>{trueOps.label || trueOps}</Tag> :
            <Icon name="check-circle" style={{ color: trueOps?.color || 'green' }} />)
          :
          (falseOps ?
            <Tag icon={<Icon name={falseOps.icon || "close-circle"} />} color={falseOps.color || "error"}>{falseOps.label || falseOps}</Tag> :
            <Icon name="close-circle" style={{ color: falseOps?.color || 'red' }} />)
      }
    </>
  )
}